import { useCallback, useMemo } from 'react'
import { DisabledCover, GameName, IconWrapper, Wrapper } from './styled'
import themeAssetGameIconPlaceholderSvg from '@theme/game/icon-placeholder.svg'

interface GameIconProps {
  id?: any
  name?: string
  icon?: string
  onClick?: () => void
  disabled?: boolean
}

export default function GameIcon({ id, name, icon, onClick, disabled = false }: GameIconProps) {
  const url = useMemo(() => `${icon}`, [icon])
  // baseUrl removed if not needed, or kept

  const clickAction = useCallback(() => {
    if (!disabled) onClick?.()
  }, [disabled, onClick])

  return (
    <Wrapper onClick={clickAction}>
      <IconWrapper>
        <img
          src={url}
          alt=""
          onError={(e) => ((e.target as HTMLImageElement).src = themeAssetGameIconPlaceholderSvg)}
        />
        {disabled && <DisabledCover />}
      </IconWrapper>
      <GameName>{name}</GameName>
    </Wrapper>
  )
}
